var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"caret-container"},[_c('b-icon-caret-down-fill',{staticClass:"dropdown-caret"}),_c('b-icon-caret-down',{staticClass:"dropdown-caret-fill"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }